<mat-card class="example-card">
  <mat-card-header class="card-header">
    <mat-card-title class="card-titulo">{{'Movimiento' | translate}} Recurrente</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
  </mat-card-header>

  <mat-card-content style="margin-bottom: 0%;">

    <mat-label class="text-style" *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    <mat-label class="text-style" *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
    <mat-label class="text-style" *ngIf="!isSearching && msgError.length > 0">{{msgError}}</mat-label>

    <div *ngIf="!isValidating">

      <mat-expansion-panel [expanded]="true" style="margin-bottom: 1%;">

        <mat-expansion-panel-header>
          <mat-panel-title class="card-subtitulo">
            <mat-icon style="margin-top: -3px;">playlist_add_check</mat-icon> Listado de Deudas Recurrentes
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <!-- FILTROS DE BUSQUEDA -->
        <mat-expansion-panel *ngIf="!isValidating">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px;">search</mat-icon> Filtros de Búsqueda
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <form [formGroup]="searchForm">

            <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!checkVerSoloRecurrentes()">

              <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%" >
                  <mat-label class="text-style">Fecha Movimiento Desde</mat-label>
                  <input class="text-style" matInput [matDatepicker]="fechaMovimientoDesdePicker" formControlName="FechaMovimientoDesde"  (click)="fechaMovimientoDesdePicker.open()">
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaMovimientoDesdePicker">
                  </mat-datepicker-toggle>
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaMovimientoDesde')">
                    <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                  </mat-datepicker-toggle>
                  <mat-datepicker #fechaMovimientoDesdePicker></mat-datepicker>
                </mat-form-field>
              </div>
              <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label class="text-style">Fecha Movimiento Hasta</mat-label>
                  <input class="text-style" matInput [matDatepicker]="fechaMovimientoHastaPicker" formControlName="FechaMovimientoHasta"  (click)="fechaMovimientoHastaPicker.open()">
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaMovimientoHastaPicker">
                  </mat-datepicker-toggle>
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaMovimientoHasta')">
                    <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                  </mat-datepicker-toggle>
                  <mat-datepicker #fechaMovimientoHastaPicker></mat-datepicker>
                </mat-form-field>
              </div>
              <div *ngIf="!isRosbaco" fxFlex=33 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label class="text-style" *ngIf="!isEstadoSearching">Estados</mat-label>
                  <mat-label class="text-style" *ngIf="isEstadoSearching">Cargando...</mat-label>
                  <mat-select multiple class="text-style" formControlName="Estados" [compareWith]="compareEstados">
                    <mat-option class="text-style" *ngFor="let s of estadoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div *ngIf="!isRosbaco" fxFlex=33 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%" >
                  <mat-label class="text-style">Fecha Vencimiento Desde</mat-label>
                  <input class="text-style" matInput [matDatepicker]="fechaVencimientoDesdePicker" formControlName="FechaVencimientoDesde"  (click)="fechaVencimientoDesdePicker.open()">
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaVencimientoDesdePicker">
                  </mat-datepicker-toggle>
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaVencimientoDesde')">
                    <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                  </mat-datepicker-toggle>
                  <mat-datepicker #fechaVencimientoDesdePicker></mat-datepicker>
                </mat-form-field>
              </div>
              <div *ngIf="!isRosbaco" fxFlex=33 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label class="text-style">Fecha Vencimiento Hasta</mat-label>
                  <input class="text-style" matInput [matDatepicker]="fechaVencimientoHastaPicker" formControlName="FechaVencimientoHasta"  (click)="fechaVencimientoHastaPicker.open()">
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaVencimientoHastaPicker">
                  </mat-datepicker-toggle>
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaVencimientoHasta')">
                    <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                  </mat-datepicker-toggle>
                  <mat-datepicker #fechaVencimientoHastaPicker></mat-datepicker>
                </mat-form-field>
              </div>
              <div *ngIf="!isRosbaco" fxFlex=33 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label class="text-style" *ngIf="!isMonedaSearching">Moneda</mat-label>
                  <mat-label class="text-style" *ngIf="isMonedaSearching">Cargando...</mat-label>
                  <mat-select class="text-style" formControlName="MonedaId">
                    <mat-option class="text-style">Todos</mat-option>
                    <mat-option class="text-style" *ngFor="let s of monedaList" [value]="s.Id">{{s.Codigo}} - {{s.Nombre}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label class="text-style" *ngIf="!isTipoSearching">Tipo de Movimiento</mat-label>
                  <mat-label class="text-style" *ngIf="isTipoSearching">Cargando...</mat-label>
                  <mat-select class="text-style" formControlName="TipoMovimientoId">
                    <mat-option class="text-style">Todos</mat-option>
                    <mat-option class="text-style" *ngFor="let s of tipoMovimientoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

            </div>

            <div fxLayout="row stretch" fxLayout.xs="column">

              <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                <mat-checkbox formControlName="VerSoloRecurrentes" color="primary">Ver solo movimientos recurrentes</mat-checkbox>
              </div>
              <ng-container *ngIf="!checkVerSoloRecurrentes()">
                <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                  <mat-checkbox formControlName="VerSoloDeudasPendientes" (keyup.enter)="searchMovimientosRecurrentes()" color="primary">Ver solo deudas pendientes</mat-checkbox>
                </div>
                <!-- <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                  <mat-checkbox formControlName="VerSoloActivos" (keyup.enter)="searchMovimientosRecurrentes()" color="primary">Ver solo activos</mat-checkbox>
                </div> -->
              </ng-container>

            </div>

            <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 10px;" *ngIf="!checkVerSoloRecurrentes()">
              <button mat-raised-button (click)="searchMovimientosRecurrentes()" [disabled]="isProcessing()" color="primary" class="zb-button">{{isMovimientoDeudaSearching ? 'Buscando...' : 'Buscar'}}</button>
            </div>

          </form>

        </mat-expansion-panel>

        <br/>

        <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true" style="padding-top: 10px;">
              <mat-label><b>TOTAL A PAGAR:</b></mat-label>
              <br/>
              <ng-container *ngIf="!isSearching">
                <mat-label *ngFor="let item of totalesSeleccionados" style="margin: 10px 0px 0px 10px;">
                  <b>{{item.key}}:</b> <span style="margin-left: 5px;" [ngStyle]="{ color: (item.value < 0) ? 'indianred' : 'black' }">{{item.value | number: '1.2-2'}}</span> <br/>
                </mat-label>
              </ng-container>
            </mat-expansion-panel>
          </div>

        </div>

        <!--GRILLA DE DEUDAS-->
        <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

          <div fxFlex=100 fxFlex.xs=100 class="flex-item">

            <mat-expansion-panel [expanded]="true" hideToggle="false">

              <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="isMovimientoDeudaSearching">
                <mat-label class="text-style"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
              </div>

              <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isMovimientoDeudaSearching" style="margin-top: 15px;">

                <ejs-grid #deudasGrid [dataSource]='deudasPendientesList' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions'
                  [selectionSettings]='selectionOptions' [pageSettings]='pageSettings' [allowResizing]='true'>
                  <e-columns>
                    <e-column field='FechaMovimiento' headerText='Fecha Movimiento' width="12%"></e-column>
                    <e-column field='FechaVencimiento' headerText='Vencimiento' width="12%"></e-column>
                    <e-column field='CuentaImputada' headerText='Referencia' width=90></e-column>
                    <e-column field='Detalle' headerText='Detalle' width="20%"></e-column>
                    <e-column field='TipoMovimientoNombre' headerText='Tipo' width="15%"></e-column>
                    <e-column field='Moneda' headerText='Moneda' width="10%"></e-column>
                    <e-column field='MontoBase' headerText='Monto Base' width="14%" format="N2"></e-column>
                    <e-column field='AlicuotaIvaId' headerText='IVA' width="10%"></e-column>
                    <e-column field='Estado' headerText='Estado' width="9%" *ngIf="canChangeState"></e-column>
                    <e-column headerText='' width="7%"></e-column>
                  </e-columns>
                  <ng-template #rowTemplate let-data>
                    <tr class="e-row">
                      <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
                        <input class="text-style" matInput [matDatepicker]="fechaMovimientoPicker" [(ngModel)]="data.FechaMovimiento" name="FechaMovimiento"  (click)="fechaMovimientoPicker.open()"
                          (dateChange)="onDeudaGridFieldChange(data.Id, $event)" style="padding: 4px 2px; width: 90%; border: 1px black solid; text-align: left;">
                        <mat-datepicker #fechaMovimientoPicker></mat-datepicker>
                      </td>
                      <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
                        <input class="text-style" matInput [matDatepicker]="fechaVencimientoPicker" [(ngModel)]="data.FechaVencimiento" name="FechaVencimiento"  (click)="fechaVencimientoPicker.open()"
                          (dateChange)="onDeudaGridFieldChange(data.Id, $event)" style="padding: 4px 2px; width: 90%; border: 1px black solid; text-align: left;">
                        <mat-datepicker #fechaVencimientoPicker></mat-datepicker>
                      </td>
                      <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
                        {{data.CuentaImputada}}
                      </td>
                      <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
                        <input matInput [(ngModel)]="data.Detalle" name="Detalle" (change)="onDeudaGridFieldChange(data.Id, $event)"
                          style="padding: 4px 2px; width: 90%; border: 1px black solid; text-align: left;">
                      </td>
                      <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
                        <mat-label *ngIf="isTipoMovimientoSearching">Cargando...</mat-label>
                        <mat-select [(ngModel)]="data.TipoMovimientoId" name="TipoMovimientoId" (selectionChange)="onDeudaGridFieldChange(data.Id, $event)" *ngIf="!isTipoMovimientoSearching"
                          style="padding: 4px 2px; width: 90%; border: 1px black solid; text-align: left;">
                          <mat-option *ngFor="let s of tipoMovimientoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                        </mat-select>
                      </td>
                      <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
                        <mat-label class="text-style" *ngIf="isMonedaSearching">Cargando...</mat-label>
                        <mat-select class="text-style" [(ngModel)]="data.MonedaId" name="MonedaId" (selectionChange)="onDeudaGridFieldChange(data.Id, $event)" *ngIf="!isMonedaSearching"
                          style="padding: 4px 2px; width: 90%; border: 1px black solid; text-align: left;">
                          <mat-option class="text-style" *ngFor="let s of monedaList" [value]="s.Id">{{s.Codigo}} - {{s.Nombre}}</mat-option>
                        </mat-select>
                      </td>
                      <td class="e-rowcell" style="text-align: center; padding: 5px 10px;">
                        <input matInput type="number" [(ngModel)]="data.MontoBase" name="MontoBase" (change)="onDeudaGridFieldChange(data.Id, $event)"
                          style="padding: 4px 2px; width: 90%; border: 1px black solid; text-align: right;">
                      </td>
                      <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
                        <mat-label *ngIf="isAlicuotaIvaSearching">Cargando...</mat-label>
                        <mat-select [(ngModel)]="data.AlicuotaIvaId" name="AlicuotaIvaId" (selectionChange)="onDeudaGridFieldChange(data.Id, $event)" *ngIf="!isAlicuotaIvaSearching"
                          style="padding: 4px 2px; width: 90%; border: 1px black solid; text-align: left;">
                          <mat-option *ngFor="let s of alicuotaIvaList" [value]="s.Id">{{s.Nombre}}</mat-option>
                        </mat-select>
                      </td>
                      <td class="e-rowcell" style="text-align: center; padding: 3px 0px;" *ngIf="canChangeState">
                        <mat-label *ngIf="isEstadoSearching">Cargando...</mat-label>
                        <mat-select [(ngModel)]="data.EstadoId" name="EstadoId" (selectionChange)="onDeudaGridFieldChange(data.Id, $event)" *ngIf="!isEstadoSearching"
                          style="padding: 4px 2px; width: 90%; border: 1px black solid; text-align: left;">
                          <mat-option *ngFor="let s of estadoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                        </mat-select>
                      </td>
                      <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
                        <a style="cursor: pointer; margin-right: 5px" (click)="openAdjuntos(data)" *ngIf="data.Adjuntos != null && data.Adjuntos.length > 0" [title]="data.Adjuntos.length + ' archivos adjuntos'">
                          <i class="fa fa-file fa-1x"></i>
                        </a>
                        <a style="cursor: pointer; margin-right: 5px" (click)="adjuntoInput.click()" [disabled]="isFileAttaching" title="Adjuntar archivos al movimiento">
                          <i class="fa fa-upload fa-1x"></i>
                          <input hidden (change)="onFileAttach(data.Id, $event)" #adjuntoInput type="file" multiple>
                        </a>
                        <!-- <mat-label *ngIf="isFileAttaching"><br /><i class="fa fa-spinner fa-spin"></i> Subiendo archivo...</mat-label> -->
                        <a style="cursor: pointer; margin-right: 5px" (click)="onRemove(data.Id)" title="Eliminar del listado">
                          <i class="fa fa-times fa-1x"></i>
                        </a>
                      </td>
                    </tr>
                  </ng-template>
                </ejs-grid>

              </div>

              <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isMovimientoDeudaSearching" style="margin-top: 15px; text-align: right;">
                <mat-checkbox [(ngModel)]="solicitarConfirmacion">Solicitar confirmación para cada acción</mat-checkbox>
              </div>

            </mat-expansion-panel>

          </div>

        </div>

      </mat-expansion-panel>

    </div>

  </mat-card-content>

  <mat-card-actions>
    <div class="flex-actions">
      <button mat-raised-button (click)="onGuardar()" [disabled]="isProcessing()" color="primary" class="zb-button" *ngIf="deudasPendientesList != null && deudasPendientesList.length > 0">
        {{isSaving ? 'Guardando...' : 'Guardar'}}
      </button>
      <button mat-raised-button (click)="onCancel()" color="warn">Cancelar</button>
    </div>
  </mat-card-actions>

</mat-card>
